export const signupSxs = {
  termsBox: {
    display: 'flex',
    alignItems: 'start'
  },
  checkBoxSx: {
    padding: 0,
    marginRight: '8px'
  },
  termsTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-mid)'
  },
  spanTextSx: {
    textDecoration: 'underline',
    color: 'var(--color-primary)',
    fontWeight: 500,
    cursor: 'pointer'
  },
  dropdown: {
    textAlign: 'left'
  },
  termAlertSx: {
    marginBottom: '10px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: '25px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'center',
    color: 'var(--color-primary)',
    marginTop: '12px'
  },
  titleBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  alreadyRegisterSx: {
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-purple)'
  },
  loginSpanSx: {
    fontWeight: 500,
    color: 'var(--color-primary)',
    cursor: 'pointer'
  },
  sqSpBtnSx: {
    padding: '12px 18px 12px 18px',
    gap: '8px',
    borderRadius: '6px',
    //width: { sm: 250, lg: 380 },
    width: '100%',
    border: '1px solid #A09DAB !important',
    marginTop: '16px'
  },
  sqSpText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  orSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  },
  dividerBoxSx: {
    marginTop: '24px',
    marginBottom: '6px'
  },
  textFieldSx: {
    //maxWidth: '23.25rem'
  },
  sqSpDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-mid)'
  },
  backToSignUpSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  backToSignUpBoxSx: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    marginRight: 'auto',
    flex: 'none'
    // paddingLeft: '1rem'
  },
  invitedByTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-mid)',
    mt: 1,
    mb: 1
  },
  eyeOffIcon: {
    color: 'var(--color-text-mid)',
    width: '16px',
    height: '16px'
  },
  memberLoginBoxSx: {
    marginTop: '0px !important'
  },
  headerBoxSx: {
    width: '100%',
    marginBottom: 0
  },
  createAccountBtnBox: {
    width: '100%'
  },
  mainStackSx: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  themeBoxSx: {
    gap: '30px'
  },
  signUpContainer: {
    display: 'flex',

    flex: 10,
    alignItems: 'center'
  },
  sqspMainBoxSx: {
    height: '100vh'
  },
  sqspThemeBox: {
    height: '100%',
    justifyContent: 'space-between'
  },
  sqspFormBoxSx: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    gap: '40px',
    width: '100%'
  },
  sqspFormDivSx: {
    width: '100%',
    height: '50%',
    marginTop: '30px',
    paddingTop: '15px',
    flex: 10
  },
  sqspSubBoxSx: {
    boxShadow: 'none',
    width: '75%',
    maxWidth: '450px',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    backgroundColor: 'transparent'
  },
  sqspAlertSx: {
    minWidth: { xs: '380px', md: '450px' }
  },
  accessDeniedErrorSQAPSx: {
    fontSize: 'var(--font-size-14)',
    lineHeight: '1.5',
    textAlign: 'justify',
    letterSpacing: '0.2px',
    fontFamily: 'Inter',
    display: 'inline'
  },
  accessDeniedErrorSQAPLinkSx: {
    fontSize: 'var(--font-size-14)',
    lineHeight: '1.5',
    textAlign: 'justify',
    letterSpacing: '0.2px',
    fontFamily: 'Inter',
    color: 'var(--color-error-alt)',
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  avatarSx: {
    height: '24px',
    width: '30px',
    marginRight: '10px',
    borderRadius: 0
  },
  createAccountLinkSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    margin: '0px 0 0 0',
    color: 'var(--color-text-grey2)'
  },
  paddingBox: {
    paddingTop: { xs: '4rem', limit1600: '10rem' }
  }
};

export const signUpToolPageSxs = {
  mainContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: '25px'
  },
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-30)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-38)',
    textAlign: 'center',
    color: 'var(--color-white)',
    paddingTop: '50px',
    marginBottom: '8px'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-white)',
    marginBottom: '8px',
    maxWidth: '24rem',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  descSpanSx: {
    fontWeight: 600,
    color: 'var(--color-secondary)'
  },
  footerTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-white)',
    marginBottom: '12px'
  },
  imgStyle: {
    maxHeight: '27rem'
  },
  avatarBoxSx: {},
  firstContainerSx: {}
};

export const signupScorePageSx = {
  mainContainerAvatar: {
    gap: '25px'
  },
  signScoreBoxSx: {
    display: { xs: 'grid', tg: 'flex' },
    borderRadius: '12px',
    backgroundColor: 'var(--color-white)',
    alignItems: 'center',
    marginBottom: '16px'
  },
  avatarBoxSx: {
    display: 'flex',
    gap: '16px',
    alignItems: 'baseline',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    paddingTop: '4rem'
  },
  scoreBox: {
    padding: '24px'
  },
  divider: {
    borderColor: '#E0E0E6'
  },
  scoreSuggestionDesc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-mid)',
    padding: '16px'
  },
  suggestionSubBoxSx: {
    padding: '16px'
  },
  suggestionHeading: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-muted)',
    marginBottom: '4px'
  },
  issueText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
    //maxWidth: '20rem'
  },
  improveSeoBtnSx: {
    padding: '8px 16px 8px 16px',
    borderRadius: '6px',
    justifyContent: 'space-between'
  },
  improveSeoTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  btnBoxSx: {
    padding: '16px'
  },
  sqspDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-white)',
    maxWidth: '20rem'
  },
  sqspDescSpanSx: {
    fontWeight: 600,
    color: 'var(--color-secondary)'
  },
  scoreTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-white)',
    marginBottom: '16px'
  },
  mainContainer: {
    paddingLeft: { xs: '20px', md: '60px' },
    paddingRight: { xs: '20px', md: '60px' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Centers content in the main container
    alignItems: 'center',
    height: '100%' // Ensures full viewport height
  },
  signUpBoxSx: {
    //height: '100%',
    flex: 10,
    display: 'flex',
    alignItems: 'center'
  },
  scoreContainerSx: {
    //flexGrow: 1,
    flexGrow: 0.4,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: '8rem',
    width: '100%'
  },
  mainBgContainer: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'var(--color-primary)',
    backgroundPosition: 'bottom'
  },
  fullScoreBoxSx: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '24px',
    minHeight: '206px',
    justifyContent: 'center'
  },
  fullScoreTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'center',
    color: 'var(--color-text-muted)',
    marginBottom: '8px'
  },
  fullScoreDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'center',
    color: 'var(--color-text-secondary)',
    maxWidth: '19rem'
  },
  suggestionListBoxSx: {
    maxHeight: '250px', // Adjust height as needed
    overflowY: 'auto', // Enables vertical scrolling when needed
    scrollbarWidth: 'thin', // For Firefox
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      borderRadius: '10px'
    }
  }
};

export const signupScoreProgressSx = {
  mainStack: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 185,
    height: 185
  },
  bgCircle: {
    color: 'var(--color-bg-mid-grey)',
    position: 'absolute'
  },
  foregroundCircle: {
    position: 'absolute',
    '& .MuiCircularProgress-circle': {
      strokeLinecap: 'round' // Adds the rounded end to the progress
    }
  },
  centeredContentSx: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinner: {
    color: 'var(--color-bg-mid-grey)'
  },
  mainBoxContent: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'center',
    color: 'var(--color-text-purple)'
  },
  spanSx: {
    fontSize: 'var(--font-size-36)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-44)',
    color: 'var(--color-primary)'
  },
  typoSx: {
    fontSize: '16.2px',
    fontWeight: 600,
    lineHeight: '25.2px'
  }
};

export const localSeoSignUpSx = {
  mainContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '22px',
    width: '100%',
    height: '100%'
  }
};
